import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { PointsRedemptionResponse } from '../../api/profile';

interface DiscountDetailsProps {
  appliedDiscounts: Array<{
    id: number;
    code: string;
    name: string;
    category: string;
    discountAmount: number;
    discountType: string;
    value: number;
    description: string;
    combinable: boolean;
    combineWithProductDiscounts: boolean;
    combineWithOrderDiscounts: boolean;
    combineWithShippingDiscounts: boolean;
    isAutomatic: boolean;
    appliedAt: string;
  }>;
  currency: string;
  display: {
    productDiscount: string;
    promoDiscount: string | null;
    totalDiscount: string;
  };
  // Optional: Cart items to get product names for product-specific discounts
  cartItems?: Array<{
    productId: number;
    product: {
      name: string;
    };
  }>;
  appliedPoints?: PointsRedemptionResponse | null;
}

const DiscountDetails: React.FC<DiscountDetailsProps> = ({ 
  appliedDiscounts, 
  currency, 
  display,
  appliedPoints
}) => {
  // Include all discounts (including product-specific ones) in the general section
  const allDiscounts = appliedDiscounts;
  
  // Filter out automatic discounts (they will be shown separately)
  const manualDiscounts = allDiscounts.filter(discount => !discount.isAutomatic);
  const automaticDiscounts = allDiscounts.filter(discount => discount.isAutomatic);

  return (
    <Box>
      {/* Sale Discount */}
              {display.productDiscount && display.productDiscount !== '-HK$0.00' && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          sx={{ pl: 4 }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <LocalOfferIcon
                sx={{
                  fontSize: '12px',
                  color: '#4CAF50',
                  width: '14px',
                  height: '14px',
                }}
              />
            <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
              Sale
            </Typography>
          </Box>
          <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
            {display.productDiscount}
          </Typography>
        </Box>
      )}

      {/* Points Discount */}
      {appliedPoints && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          sx={{ pl: 4 }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <LocalOfferIcon
              sx={{
                fontSize: '12px',
                color: '#4CAF50',
                width: '14px',
                height: '14px',
              }}
            />
            <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
              Points Discount
            </Typography>
          </Box>
          <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
            -{currency}{appliedPoints.discountAmount.toFixed(2)}
          </Typography>
        </Box>
      )}

      {/* Automatic Discounts */}
      {automaticDiscounts.map((discount) => (
        <Box
          key={discount.id}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          sx={{ pl: 4 }}
        >
          <Box display="flex" alignItems="center" gap={1}>
              <LocalOfferIcon
                sx={{
                  fontSize: '12px',
                  color: '#4CAF50',
                  width: '14px',
                  height: '14px',
                }}
              />
            <Box display="flex" alignItems="center" gap={1}>
              <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
                {discount.code}
              </Typography>
              <Chip
                label="AUTO"
                size="small"
                sx={{
                  height: 16,
                  fontSize: '10px',
                  fontWeight: 700,
                  backgroundColor: '#E3F2FD',
                  color: '#1976D2',
                  '& .MuiChip-label': {
                    px: 1,
                  },
                }}
              />
            </Box>
          </Box>
          <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
            -{currency}{discount.discountAmount ? discount.discountAmount.toFixed(2) : '0.00'}
          </Typography>
        </Box>
      ))}

            {/* Manual Promo Discounts */}
      {manualDiscounts.map((discount) => (
        <Box key={discount.id}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
            sx={{ pl: 4 }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <LocalOfferIcon
                sx={{
                  fontSize: '12px',
                  color: '#4CAF50',
                  width: '14px',
                  height: '14px',
                }}
              />
              <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
                {discount.code}
              </Typography>
            </Box>
            <Typography sx={{ color: '#4CAF50', fontSize: '14px', fontWeight: 400 }}>
              -{currency}{discount.discountAmount ? discount.discountAmount.toFixed(2) : '0.00'}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default DiscountDetails; 